import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SyncStatusCard = ({ marketplace, icon, status, onConfigure }) => {
  const getStatusColor = () => {
    if (!status?.connected) return 'error';
    if (status?.pendingOps > 50) return 'warning';
    return 'success';
  };

  const statusColor = getStatusColor();

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
            <Icon name={icon} size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">{marketplace}</h3>
            <p className="text-xs text-muted-foreground">Status de Sincronização</p>
          </div>
        </div>
        <button
          onClick={onConfigure}
          className="w-8 h-8 rounded-lg bg-muted/30 border border-border hover:bg-muted flex items-center justify-center transition-smooth"
          title="Configurações"
        >
          <Icon name="Settings" className="w-4 h-4 text-muted-foreground" />
        </button>
      </div>

      {/* Connection Status */}
      <div className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
        <span className="text-sm text-muted-foreground">Conexão</span>
        <div className="flex items-center gap-2">
          <div 
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: `var(--color-${statusColor})` }}
          />
          <span 
            className="text-sm font-semibold"
            style={{ color: `var(--color-${statusColor})` }}
          >
            {status?.connected ? 'Conectado' : 'Desconectado'}
          </span>
        </div>
      </div>

      {/* Metrics Grid */}
      <div className="grid grid-cols-3 gap-3">
        <div className="p-3 rounded-lg bg-muted/30">
          <p className="text-xs text-muted-foreground mb-1">Última Sync</p>
          <p className="text-sm font-semibold text-foreground">
            {status?.lastSync 
              ? new Date(status?.lastSync)?.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
              : 'N/A'
            }
          </p>
        </div>
        <div className="p-3 rounded-lg bg-muted/30">
          <p className="text-xs text-muted-foreground mb-1">Pendentes</p>
          <p className="text-sm font-semibold text-foreground">{status?.pendingOps || 0}</p>
        </div>
        <div className="p-3 rounded-lg bg-muted/30">
          <p className="text-xs text-muted-foreground mb-1">Throughput</p>
          <p className="text-sm font-semibold text-foreground">{status?.throughput || 0}/h</p>
        </div>
      </div>

      {/* Quick Actions */}
      {!status?.connected && (
        <Button
          variant="outline"
          iconName="RefreshCw"
          iconPosition="left"
          onClick={onConfigure}
          fullWidth
        >
          Reconectar
        </Button>
      )}
    </div>
  );
};

export default SyncStatusCard;